import { pointIcon, rupiahIcon, unlockIcon } from '../constants/images-library'

import formatCurrency from './format-currency'

type TRewardFormatProps = {
  useOwnLoyaltyPlatform?: boolean
  loyaltyPlatform?: {
    loyaltyPlatformIcon: string
    loyaltyPlatformName: string
    loyaltyPlatformPrefix?: string
    loyaltyPlatformSuffix?: string
  }
  rewardType?: string
  rewardPrefix?: string
  rewardAmount: number
  isRewardBalance?: boolean
}

export const rewardFormat = ({
  useOwnLoyaltyPlatform,
  loyaltyPlatform,
  rewardType,
  rewardPrefix,
  rewardAmount,
  isRewardBalance,
}: TRewardFormatProps) => {
  // eslint-disable-next-line prefer-const
  let rewardDetail: {
    reward: string | number
    prefix?: string | null
    suffix?: string | null
    image?: { src: string; alt: string }
  } = {
    reward: formatCurrency(rewardAmount ?? 0),
    prefix: null,
    suffix: null,
    image: { src: '', alt: '' },
  }
  if (rewardAmount === 0 && !isRewardBalance) {
    rewardDetail.prefix = 'Unlock more surveys'
    rewardDetail.reward = ''
    rewardDetail.image = {
      src: unlockIcon.src,
      alt: unlockIcon.alt,
    }
  } else if (useOwnLoyaltyPlatform) {
    rewardDetail.prefix = (rewardPrefix ?? '') + (loyaltyPlatform?.loyaltyPlatformPrefix ?? '')
    rewardDetail.suffix = loyaltyPlatform?.loyaltyPlatformSuffix ?? ''
    rewardDetail.image = {
      src: loyaltyPlatform?.loyaltyPlatformIcon ?? '',
      alt: 'loyalty-icon',
    }
  } else if (rewardType === 'POINT') {
    rewardDetail.suffix = 'Points'
    rewardDetail.reward = rewardAmount ?? 0
    rewardDetail.image = {
      src: pointIcon.src,
      alt: pointIcon.alt,
    }
  } else {
    rewardDetail.prefix = (rewardPrefix ?? '') + 'Rp'
    rewardDetail.image = {
      src: rupiahIcon.src,
      alt: rupiahIcon.alt,
    }
  }
  return rewardDetail
}
